import { Icon, symbolName } from './Icon'

type ExternalLinkIconProps = Readonly<{
  size?: number
  color?: string
}>

export function ExternalLinkIcon({
  size = 24,
  color = '#777777',
}: ExternalLinkIconProps) {
  return (
    <Icon
      name={symbolName('arrow.up.right.square', 'open_in_new')}
      size={size}
      color={color}
    />
  )
}
